import React, {useEffect} from 'react'
import {useHistory} from 'react-router-dom'
import * as echarts from 'echarts'
import {Button} from 'antd'
const EvaluationResultPage = () => {
  const history = useHistory()
  const state: any = history.location.state

  let option = {
    backgroundColor: 'transparent',

    radar: {
      // center: ['40%', '55%'],
      indicator: [
        {name: 'AI概念', max: state.result.paper.ai_score},
        {name: '计算思维', max: state.result.paper.calc_score},
        {name: '智能意识', max: state.result.paper.inte_score},
        {name: '探究创新', max: state.result.paper.inno_score},
        {name: '智能社会责任', max: state.result.paper.soc_score},
      ],
    },
    color: ['#ff6e76', '#54ceed', '#3f7edd'],
    series: [
      {
        type: 'radar',
        data: [
          {
            value: [
              state.result.my.ai_score,
              state.result.my.calc_score,
              state.result.my.inte_score,
              state.result.my.inno_score,
              state.result.my.soc_score,
            ],
            name: '分值',
            areaStyle: {
              opacity: 0.3,
            },
            symbolSize: 4,
            lineStyle: {
              width: 1,
            },
          },
        ],
      },
    ],
  }

  useEffect(() => {
    console.log('state',state)
    let resourceRadar = document.getElementById('resourceRadar')
    let r = echarts.init(resourceRadar!, 'dark')
    r.setOption(option)
  }, [])
  return (
    <div
      style={{
        margin: '0 auto',
        width: 1200,
        height: '100%',
        padding: 24,
        backgroundColor: '#ffffff',
      }}
    >
      <div
        style={{
          textAlign: 'center',
          // fontFamily: 'Source Han Sans CN',
          fontSize: 32,
          lineHeight: 1.5,
          marginTop: 16,
          marginBottom: 40,
          color: 'rgba(38,38,38,1)',
          fontWeight: 500,
        }}
      >
        AI素养水平测试({state.title})
      </div>

      <div
        style={{
          width: 332,
          height: 102,
          background: 'rgba(0,0,0,0.02)',
          borderRadius: 4,
          padding: 16,
          margin: '0 auto',
        }}
      >
        <div style={{textAlign: 'center'}}>测试结果</div>
        <div
          style={{
            borderBottom: '1px solid rgba(0,0,0,0.08)',
            height: 40,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <div>总分</div>
          <div>{state.result.my.total}分</div>
        </div>
      </div>
      <div
        style={{
          marginTop: 48,
          marginBottom: 24,
          textAlign: 'center',
          fontSize: 24,
          fontWeight: 'bold',
        }}
      >
        AI素养五维评价模型
      </div>
      <div id="resourceRadar" style={{width: 600, height: 400, margin: '0 auto'}}></div>

      <div style={{textAlign: 'center'}}>
        <Button
          size="large"
          onClick={() => {
            history.push('/evaluation')
          }}
        >
          回到评测页面
        </Button>
      </div>
    </div>
  )
}

export default EvaluationResultPage
